import type { Severity } from '@zevik/schemas';
import { bandLabel, bandMeter } from '../review/severity';

/**
 * A severity band, carried by its word and its meter with colour reinforcing
 * (docs/DECISIONS.md ZD-112).
 *
 * `null` renders *not banded* rather than nothing: a finding whose scoring method
 * is `unscored` has no band to show, and printing an empty space where four
 * neighbours carry a band reads as a rendering fault rather than as a fact.
 */
export function Band({ band }: { band: Severity | null }): React.JSX.Element {
  if (band === null) {
    return <span className="band band--none">not banded</span>;
  }
  return (
    <span className="band" data-band={band} aria-label={bandLabel(band)}>
      <span className="band__meter" aria-hidden="true">
        {bandMeter(band)}
      </span>
      <span className="band__word">{band}</span>
    </span>
  );
}
